import ReviewsNum from './ReviewsNum'

export default ReviewsNum
